import {
  Button, Flex, Image, Text,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router';

import NotFoundLogo from 'assets/logos/light-logo.svg';

export function PageNotFound(): React.ReactNode {
  const navigate = useNavigate();
  return (
    <Flex
      dir='row' minWidth='1000px'
      justifyContent='center' align='center'
      pt='100px'
    >
      <Flex
        width='500px' flexDir='column'
        gap='20px'
      >
        <Text fontSize='36px'>Oops!</Text>
        <Text color='black' fontSize='20px'>We can&apos;t seem to find the page you&apos;re looking for.</Text>
        <Button width='50%' onClick={() => navigate('/')}>Home</Button>
      </Flex>
      <Flex width='500px'>
        <Image
          src={NotFoundLogo} w='500px'
          h='500px'
        />
      </Flex>
    </Flex>
  );
}
